import type { Issue } from "contracts/api/issue/responses";
import { lifecycleLabel, statusLabel } from "../features/website/issueModel";

// Compact, neutral-by-default pills. Color is carried by a modifier class so the
// palette lives entirely in CSS.
export function SeverityBadge(props: { severity: Issue["severity"] }) {
  return (
    <span class={`badge badge-sev sev-${props.severity}`}>
      {props.severity}
    </span>
  );
}

export function StatusBadge(props: { status: Issue["status"] }) {
  return (
    <span class={`badge badge-status st-${props.status}`}>
      {statusLabel(props.status)}
    </span>
  );
}

// What the latest scan observed about the issue — a separate axis from the
// analyst/agent status. Palette lives in CSS keyed by the modifier class.
export function LifecycleBadge(props: { state: Issue["lifecycleState"] }) {
  return (
    <span class={`badge badge-lifecycle lc-${props.state}`}>
      {lifecycleLabel(props.state)}
    </span>
  );
}

export function EffortBadge(props: { effort: Issue["effort"] }) {
  return <span class="badge badge-effort">{props.effort}</span>;
}
